<template>
  <div id="app">
    <img style="width: 100%;" src="https://oss.mcloud.moveclub.cn/2025/mv/Q%26A_h5.png" />
    <QuestionForm />
  </div>
</template>

<script>
import QuestionForm from './components/QuestionForm.vue';

export default {
  name: 'App',
  components: {
    QuestionForm
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>